export const ButtonNodeEditorConstants = {
    TITLE_INPUT_PLACEHOLDER: "Title"
}